import React, { useEffect, useMemo, useState } from "react";
import { annotateGlossaryText } from "../../../util/glossaryAnnotator";
// no lodash needed here
import "./TableV2.css";

export default function TableV2({ question, answers, handleNewAnswer, readOnly, glossary, language = 'ES' }) {
  const [local, setLocal] = useState(answers || []);

  // columnas ordenadas
  const columns = useMemo(() => {
    const cols = (question.matrixColumns || []).slice().sort((a,b) => (a.order||0)-(b.order||0));
    return cols;
  }, [question]);

  useEffect(() => {
    // sync from external answers
    setLocal(answers || []);
  }, [answers]);

  const getRowAnswer = (rowId) => (local || []).find(a => a.assessmentTemplateAnswerId === rowId);

  // Now we save the selected column as text (column label)
  const isChecked = (rowId, label) => {
    const a = getRowAnswer(rowId);
    return a && a.answerText === label;
  };

  const selectValue = (rowId, label) => {
    if (readOnly) return;
    const next = [...(local || [])];
    const idx = next.findIndex(a => a.assessmentTemplateAnswerId === rowId);
    if (idx > -1) next[idx] = { ...next[idx], answerText: label, answerNumeric: null };
    else next.push({ id: 0, assessmentTemplateAnswerId: rowId, answerText: label, answerNumeric: null });
    setLocal(next);
    handleNewAnswer(next);
  };

  const cellText = (row, col) => {
    // busca por id y si no, por code (para plantillas recién creadas)
    const cells = row.matrixCells || [];
    let c = cells.find(x => x.columnId && col.id && x.columnId === col.id);
    if (!c && col.code) c = cells.find(x => x.columnCode && x.columnCode === col.code);
    return c ? c.description : "";
  };

  return (
    <div className="matrix-container">
      <table className="table table-bordered table-sm matrix-table">
        <thead>
          <tr>
            <th className="sticky-col row-header"></th>
            {columns.map(col => (
              <th key={col.id || col.code} className="text-center col-header">
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(question.answers || []).map(row => (
            <tr key={row.id}>
              <td className="sticky-col row-header">
                <strong>{glossary ? annotateGlossaryText(glossary, row.answer, language) : row.answer}</strong>
              </td>

              {columns.map(col => (
                <td key={(col.id || col.code) + "-" + row.id} className="matrix-cell">
                  <div className="cell-inner">
                    <div className="cell-desc">{glossary ? annotateGlossaryText(glossary, cellText(row, col), language) : cellText(row, col)}</div>
                    <div className="cell-options">
                      <label className="option-number">
                        <input
                          type="radio"
                          name={`row_${row.id}`}
                          value={col.label}
                          checked={isChecked(row.id, col.label)}
                          onChange={() => selectValue(row.id, col.label)}
                          disabled={readOnly}
                          aria-label={col.label}
                        />
                        {/* Intentionally no visible text; header already shows column label */}
                      </label>
                    </div>
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
